import {
    RegisterFormBody,
    RegisterFormGlobal
} from 'components/Auth/Register/Register.types.ts';

// *
// STORE
// *

export const registerFormGlobalDefaultValues: RegisterFormGlobal = {
    name: '',
    email: '',
    phone: '',
    password: '',
    organization: '',
    isAgreedToLicensingAgreement: false,
    isAgreedToPrivacyPolicy: false
}
export const registerFormBodyInitialState: RegisterFormBody = {
    name: '',
    email: '',
    phone: '',
    password: '',
    organization: '',
    isAgreedToLicensingAgreement: false,
    isAgreedToPrivacyPolicy: false
}